
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 2.333l-1-1-1 1-1-1-1 1-1-1-1 1-1-1-1 1-1-1v9.334H2v2c0 1.106.893 2 2 2h8c1.107 0 2-.894 2-2V1.333l-1 1zm-3 11H4a.669.669 0 01-.667-.666V12H10v1.333zm2.667-.666c0 .366-.3.666-.667.666a.669.669 0 01-.667-.666v-2h-6V3.333h7.334v9.334z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10 4.667H6V6h4V4.667zM12 4.667h-1.333V6H12V4.667zM10 6.667H6V8h4V6.667zM12 6.667h-1.333V8H12V6.667z","fill":"currentColor"}})])
          )
        }
      }
    